<article class="address-card">
  <div class="address-details">
    <p class="street-line">{{ address.streetAddress }}</p>
    <p class="region-city-line">{{ address.region }}, {{ address.city }}</p>
  </div>

  <button type="button" class="edit-button" (click)="editClicked.emit(address.id)">
    <i class="pi pi-pencil"></i>
  </button>
</article>
